export const PayeezyConfig = {
  fields: {
    card: {
      selector: '[data-cc-card]',
    },
    cvv: {
      selector: '[data-cc-cvv]',
      placeholder: 'CVV',
    },
    exp: {
      selector: '[data-cc-exp]',
      placeholder: 'Expiration Date',
    },
    name: {
      selector: '[data-cc-name]',
      placeholder: 'Name on Card',
    },
  },
  styles: {
    input: {
      'font-size': '12px',
      color: 'black',
      'font-family': 'monospace',
      background: 'black',
    },
    '.card': {
      'font-family': 'monospace',
    },
    ':focus': {
      // color: '#00a9e0'
    },
    '.valid': {
      color: '#43B02A',
    },
    '.invalid': {
      color: '#C01324',
    },
    'input:focus:-webkit-autofill': {
      // '-webkit-text-fill-color': '#00a9e0',
    },
    'input.valid:-webkit-autofill': {
      '-webkit-text-fill-color': '#43B02A',
    },
    'input.invalid:-webkit-autofill': {
      '-webkit-text-fill-color': '#C01324',
    },
    'input::placeholder': {
      color: '#aaa',
    },
  },
  classes: {
    empty: 'empty',
    focus: 'focus',
    invalid: 'invalid',
    valid: 'valid',
  },
} as const;
